import React from 'react'
import { Container, Typography } from './empty-state-message.styled'

export default function EmptyStateMessage({message}) {
    return <Container>
        <Typography>{message}</Typography>
    </Container>
}

